import { Outlet } from "react-router-dom";
import Superheader from '../components/KalHome/Superheader';
import Endfooter from '../components/Homecomponents/Endfooter';

const AuthLayout = () => {
  return (
    <>
        <Superheader />
        <Outlet />
        <Endfooter />
    </>
  )
}

export default AuthLayout